(() => {
  function gbi(id) {
    return document.getElementById(id);
  }
  function html(id, htm) {
    gbi(id).innerHTML = htm;
  }

  function loadweblinks() {
    fetch('weblnk.html')
      .then((r) => r.text())
      .then((data) => html('weblinkbox', data))
      .catch(() => html('weblinkbox', 'Unable to load weblinks'));
  }

  loadweblinks();
})();
